{
  "login": {
    "join": {
      "fields": {
        "phone": {
          "phoneNumber": {
            "pattern": "Syötä oikea puhelinnumero",
            "required": "Puhelinnumero on pakollinen tieto"
          },
          "pattern": "",
          "required": ""
        },
        "guardianPhone": {
          "phoneNumber": {
            "pattern": "Syötä oikea puhelinnumero",
            "required": "Huoltajan puhelinnumero on pakollinen tieto"
          },
          "pattern": "",
          "required": ""
        },
        "gender": {
          "required": "Sukupuoli on pakollinen"
        },
        "acceptFinnairPlusRules": {
          "required": "Lue ja hyväksy Finnair Plus -ohjelman säännöt jatkaaksesi."
        }
      }
    }
  }
}
